import API from './api'

export async function getPackageForm(packageID) {
  let response
  try {
    response = await API.get(`package/${packageID}/package-form-field/?package=${packageID}`)
  } catch (error) {
    response = error.response
  }
  return response
}

export async function createPackageForm(token, packageID, data) {
  let response
  try {
    response = await API.post(`package/${packageID}/package-form-field/`, data, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function updatePackageForm(token, packageID, formID, data) {
  let response
  try {
    response = await API.patch(`package/${packageID}/package-form-field/${formID}/`, data, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function deletePackageForm(token, packageID, formID) {
  let response
  try {
    response = await API.delete(`package/${packageID}/package-form-field/${formID}/`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}
